import React from "react";
import Welcome from "../master_pobox";
import apiUrl from "../enviroments/enviroment";
import axios from 'axios';

class MisPaquetes extends React.Component{

    state = {

    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {

    }

    render(){
        return (
            <Welcome>
                <main id="js-page-content" role="main" className="page-content">
                    <div className="subheader">
                    </div>
                    <div className="fs-lg fw-300 p-5 bg-white border-faded rounded mb-g text-center" style={{backgroundImage: `url("src/img/servicios_pobox.jpg")`,height: 190}}>
                    </div>
                    <div className="fs-lg fw-300 p-5 bg-white border-faded rounded mb-g text-center text-dark">
                        Tu dirección de P.O.Box es:<br/>
                        {localStorage.getItem("nombre")} / Sec{localStorage.getItem("seccion")}<br/>
                        7801 N.W. 37th Street<br/>
                        Sec{localStorage.getItem("seccion")}<br/>
                        Doral Florida, ZipCode 33195-6503<br/>
                        Phone:  305 592 0839<br/>

                    </div>
                </main>
            </Welcome>
        )
    }
}
export default MisPaquetes;
